import React from 'react';
import { useDispatch } from 'react-redux';
import SVG from 'react-inlinesvg';
import { FormattedMessage } from 'react-intl';
import { moderatorActions, callActions as nucleusCallActions } from '@lifesize/nucleus';
import { hooks } from '@lifesize/clients.sdk';
import moreIcon from '@lifesize/ux-assets/vectors/svgIcons/more.svg';
import handIcon from '@lifesize/ux-assets/vectors/svgIcons/hand.svg';
import endCallIcon from '@lifesize/ux-assets/vectors/svgIcons/end-call.svg';
import DropdownComp from 'components/Dropdown/Dropdown';
import { getMicConfig } from 'components/InCall/InCallParticipantList/ParticipantButtons/ParticipantMicButton';
import Modals from 'constants/Modals';
import { openInCallModal } from 'actions/InCallModal';
import classes from '../InCallParticipant.module.scss';

interface Props {
  participant: any;
}

const ParticipantMoreButton = ({ participant }: Props) => {
  const userIsModerator = hooks.useIsCurrentUserModerator();
  const { handRaised, isSelf } = participant;
  const dispatch = useDispatch();
  const conferenceInfo = hooks.useConferenceInfo();
  const canBeMuted = userIsModerator && conferenceInfo?.state === 'escalated';
  const micConfig = getMicConfig(participant, userIsModerator);

  const handleLowerHandClicked = (participantId) => {
    dispatch(moderatorActions.lowerParticipantHand(participantId));
  };

  const handleMuteParticipantClicked = (participant) => {
    dispatch(nucleusCallActions.muteParticipant(participant, !participant.serverAudioMuteState));
  };

  const handleRemoveFromMeetingClicked = (participant) => {
    dispatch(openInCallModal(Modals.removeFromMeeting, { participant }));
  };

  if (userIsModerator && !isSelf) {
    return (
      <DropdownComp
        menuNoLeft
        menuNoTop
        buttonClassName={classes.dropdownButton}
        buttonComponent={
          <div className={`${classes.button} ${classes.lastButton}`} data-testid="moreDropdownMenuTrigger">
            <SVG src={moreIcon} className={classes.buttonIcon} data-testid="moreIcon" />
          </div>
        }
        containerClassName={classes.dropdown}
        openButtonComponent={
          <div className={`${classes.button} ${classes.lastButton}`} data-testid="moreDropdownMenuTrigger">
            <SVG src={moreIcon} className={classes.buttonIcon} data-testid="moreIcon" />
          </div>
        }
        dropdownClassName={classes.dropdownMenu}
        menuComponent={
          <ul>
            {!!handRaised && (
              <li
                data-testid="moreMenuOptionLowerHand"
                onClick={() => handleLowerHandClicked(participant.participantId)}
              >
                <SVG src={handIcon} className={classes.buttonIcon} />
                <span>
                  <FormattedMessage id="components.inCall.participantDrawer.lowerHand" defaultMessage="Lower Hand" />
                </span>
              </li>
            )}
            {!!canBeMuted && (
              <li
                data-testid={micConfig.menuOptionDataTestId}
                onClick={() => handleMuteParticipantClicked(participant)}
              >
                <SVG src={micConfig.menuOptionIcon} className={classes.buttonIcon} />
                <span>{micConfig.menuOptionLabel}</span>
              </li>
            )}
            <li
              data-testid="moreMenuOptionRemoveFromMeeting"
              onClick={() => handleRemoveFromMeetingClicked(participant)}
            >
              <SVG src={endCallIcon} className={classes.buttonIcon} />
              <span>
                <FormattedMessage
                  id="components.inCall.participantDrawer.removeFromMeeting"
                  defaultMessage="Remove from Meeting"
                />
              </span>
            </li>
          </ul>
        }
      />
    );
  }
  // non-moderators see nothing (blank space)
  return <div className={`${classes.button} ${classes.noButton} ${classes.lastButton}`} />;
};

export default ParticipantMoreButton;
